import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=c8f4bb74&"
import script from "./ErrorBanner.vue?vue&type=script&lang=js&"
export * from "./ErrorBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports